/** An object of space keys and px values (strings) */
export const space = {
    zero: '0px',
    xxxs: '4px',
    xxs: '8px',
    xs: '12px',
    s: '16px',
    m: '24px',
    l: '32px',
    xl: '40px',
    xxl: '64px',
    xxxl: '80px',
};
/**
 * An object of space keys and their numeric px values (numbers)
 * - These are helpful when you need a raw numeric px value.
 * - Here's an example usage to perform calculations:
 * @example
 * const buttonPaddingLeft = spaceNumbers.s + iconSize;
 */
export const spaceNumbers = {
    zero: 0,
    xxxs: 4,
    xxs: 8,
    xs: 12,
    s: 16,
    m: 24,
    l: 32,
    xl: 40,
    xxl: 64,
    xxxl: 80,
};
